import { createContext } from "react";

const BlogsContext = createContext();

export default BlogsContext;
